async function fetchApi(action, parameters = {}) {
  const response = await fetch('./api.php', {
    method: 'POST',
    cache: 'no-store',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      action,
      parameters,
    }),
  });
  if (!response.ok) {
    throw new Error('Unsuccessful Response Status');
  }
  return response.json();
}

/* eslint-disable import/prefer-default-export */
export {
  fetchApi,
};
